/* Product navigation yields to reading, then returns on upward scroll. */
(() => {
 const header = document.querySelector('body.template-product #shopify-section-header-inline');
 if (!header || header.hasAttribute('data-aldeno-scroll-hidden')) return;
 let previous = Math.max(0, window.scrollY);
 let travel = 0;
 let frame = 0;
 const show = () => { header.dataset.aldenoScrollHidden = 'false'; };
 const update = () => {
  frame = 0;
  const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - innerHeight));
  const delta = y - previous;
  previous = y;
  if (y <= 8 || header.querySelector(':focus-visible, [aria-expanded="true"]')) {
   travel = 0;
   show();
   return;
  }
  if (!delta) return;
  if (Math.sign(delta) !== Math.sign(travel)) travel = 0;
  travel += delta;
  if (Math.abs(travel) >= 12) {
   header.dataset.aldenoScrollHidden = travel > 0 ? 'true' : 'false';
   travel = 0;
  }
 };
 const reset = () => { previous = Math.max(0, window.scrollY); travel = 0; show(); };
 addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive:true});
 addEventListener('resize', reset);
 addEventListener('pageshow', reset);
 header.addEventListener('focusin', show);
 reset();
})();

/* Scroll state for pages outside the reviewed-page script, including Bespoke. */
(() => {
 if (window.aldenoMobileHeaderReady) return;
 window.aldenoMobileHeaderReady = true;
 let scheduled = false;
 const update = () => {
  scheduled = false;
  if (window.aldenoHeuristicReady) return;
  document.body.classList.toggle('aldeno-header-scrolled', matchMedia('(max-width:1024px)').matches && scrollY > 70);
 };
 addEventListener('scroll', () => { if (!scheduled) {scheduled=true;requestAnimationFrame(update);} }, {passive:true});
 addEventListener('resize', update);
 addEventListener('pageshow', update);
 update();
})();

/* Keep Back to Top above the visible product-selection footer. */
(() => {
 const footers = [...document.querySelectorAll('[data-mb-footer-global], [data-mb-footer]')];
 if (!footers.length) return;
 let frame = 0;
 let previous = -1;
 const update = () => {
  frame = 0;
  let clearance = 0;
  if (matchMedia('(max-width:767px)').matches) {
   footers.forEach(footer => {
    const style = getComputedStyle(footer);
    const rect = footer.getBoundingClientRect();
    if (!footer.hidden && style.display !== 'none' && style.visibility !== 'hidden' && style.position === 'fixed' && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0) {
     clearance = Math.max(clearance, innerHeight - rect.top + 12);
    }
   });
  }
  if (clearance !== previous) {
   document.documentElement.style.setProperty('--aldeno-selection-clearance', clearance + 'px');
   previous = clearance;
  }
 };
 const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
 const resize = new ResizeObserver(schedule);
 const changes = new MutationObserver(schedule);
 footers.forEach(footer => {
  resize.observe(footer);
  changes.observe(footer, {attributes:true, attributeFilter:['hidden','class','style']});
 });
 addEventListener('resize', schedule);
 addEventListener('pageshow', schedule);
 update();
})();
